import { createStore } from "@wxn0brp/flanker-ui";

export const settings = createStore({
	proxyUrl: "",
});
